import React from 'react';
import { Box, Container } from '@mui/material';
import { TabList } from '@mui/lab';

export interface TabNavProps {
  onChange: (value: string) => void;
  children: React.ReactNode;
  divider?: boolean;
}

const TabNav = ({ onChange, children, divider = true }: TabNavProps) => {
  const handleChange = (_: any, newValue: string) => onChange(newValue);

  return (
    <Box sx={{ borderBottom: divider ? (theme) => `1px solid ${theme.palette.divider}` : 'none' }}>
      <Container>
        <TabList onChange={handleChange}>{children}</TabList>
      </Container>
    </Box>
  );
};

export default TabNav;
